import { Box, Card, CardContent, Chip, Grid, Stack, Typography } from '@mui/material';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import $ from "jquery";
import * as React from 'react';
import Common from '../utilities/common';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/ThumbUpOffAltOutlined';
import ThumbDownOffAltOutlinedIcon from '@mui/icons-material/ThumbDownOffAltOutlined';
import { LineChart } from '@mui/x-charts/LineChart';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';

export interface INormalizationDashboardProps {
    normalization: any,
    onItemClick?: any
}

export interface INormalizationDashboardState {
    normalization: any,
    data: any[],
    fieldsWithErrors: any[],
    errorCount: any[],
    totalErrors: number,
    totalSuccess: number,
    itemCount: number,
    itemSelected: string,
    itemError: number,
    lineChartLabels: string[],
    lineChartTotals: number[],
    percentageNormalizations: number,
    fieldsWithoutErrors: any[];
}

export default class NormalizationDashboard extends React.Component<INormalizationDashboardProps, INormalizationDashboardState> {
    public constructor(props: INormalizationDashboardProps) {
        super(props);

        this.state = {
            normalization: null,
            data: [],
            fieldsWithErrors: [],
            errorCount: [],
            totalErrors: 0,
            totalSuccess: 0,
            itemCount: 0,
            itemSelected: '',
            itemError: -1,
            lineChartLabels: [],
            lineChartTotals: [],
            percentageNormalizations: -1,
            fieldsWithoutErrors: []
        }
    }

    componentWillReceiveProps(nextProps: Readonly<INormalizationDashboardProps>, nextContext: any): void {
        this.GetData();
        this.GetTotal();
    }

    componentDidMount(): void {
        this.GetData();
        this.GetTotal();
        this.GetNormalizationData();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.props.normalization.status != "Consolidada" && (
                        <React.Fragment>
                            <Box className='main' style={{marginTop: '20px'}}>
                                <Typography variant="h6">
                                Resumen de errores
                                </Typography>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-start'} gap={'20px'} whiteSpace={'break-spaces'}>
                                    <Box className='square info-bg'>
                                        <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                        Registros
                                        </Typography>
                                        <Typography variant='h3' color="text.secondary" gutterBottom textAlign='center'>
                                            {
                                                this.state.itemCount.toLocaleString()
                                            }
                                        </Typography>
                                    </Box>
                                    {
                                        this.state.totalSuccess >= 0 && (
                                            <Box className='square success-bg'>
                                                <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                                Normalizaciones
                                                </Typography>
                                                <Typography variant='h3' color="text.secondary" gutterBottom textAlign='center'>
                                                    {
                                                        this.state.totalSuccess.toLocaleString()
                                                    }
                                                </Typography>
                                            </Box>
                                        )
                                    }
                                    {
                                        this.state.totalErrors >= 0 && (
                                            <Box className='square error-bg'>
                                                <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                                Errores
                                                </Typography>
                                                <Typography variant='h3' color="text.secondary" gutterBottom textAlign='center'>
                                                    {
                                                        this.state.totalErrors.toLocaleString()
                                                    }
                                                </Typography>
                                            </Box>
                                        )
                                    }
                                </Stack>
                                <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-start'} gap={'20px'} whiteSpace={'break-spaces'} mt={2}>
                                    {
                                        this.state.fieldsWithErrors.map((field: any, index: number) => {
                                            return (
                                                <Box className='square'>
                                                    <Typography className='square-title grey' variant='body2' color="text.secondary" gutterBottom>
                                                    {
                                                        `${field.campo}`
                                                    }
                                                    </Typography>
                                                    <div className='square-content'>
                                                        <Stack direction={'column'}>
                                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                                <ThumbUpOffAltOutlinedIcon style={{color: Common.SUCCESS_COLOR_DARK}}/>
                                                                <Typography variant='h4' style={{paddingLeft: '25px'}}>
                                                                {
                                                                    this.state.itemCount - this.GetErrorsTotalByField(field.campo)
                                                                }
                                                                </Typography>
                                                            </Stack>
                                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                                <ThumbDownOffAltOutlinedIcon style={{color: Common.ERROR_COLOR_DARK}}/>
                                                                <Typography variant='h4' style={{paddingLeft: '25px'}}>
                                                                {
                                                                    this.GetErrorsTotalByField(field.campo)
                                                                }
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </div>
                                                </Box>
                                            )
                                        })
                                    }
                                    {
                                        this.state.fieldsWithoutErrors.map((field: any, index: number) => {
                                            return (
                                                <Box className='square'>
                                                    <Typography className='square-title grey' variant='body2' color="text.secondary" gutterBottom>
                                                    {
                                                        `${field}`
                                                    }
                                                    </Typography>
                                                    <div className='square-content'>
                                                        <Stack direction={'column'}>
                                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                                <ThumbUpOffAltOutlinedIcon style={{color: Common.SUCCESS_COLOR_DARK}}/>
                                                                <Typography variant='h4' style={{paddingLeft: '25px'}}>
                                                                {
                                                                    this.state.itemCount - this.GetErrorsTotalByField(field)
                                                                }
                                                                </Typography>
                                                            </Stack>
                                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                                                <ThumbDownOffAltOutlinedIcon style={{color: Common.ERROR_COLOR_DARK}}/>
                                                                <Typography variant='h4' style={{paddingLeft: '25px'}}>
                                                                {
                                                                    this.GetErrorsTotalByField(field.campo)
                                                                }
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    </div>
                                                </Box>
                                            )
                                        })
                                    }
                                </Stack>
                            </Box>
                            <Box className='main' style={{marginTop: '20px'}}>
                                <Typography variant="h6">
                                    Índice de eficacia (en %)
                                </Typography>
                                <Stack direction={'row'} justifyContent={'space-around'} alignItems={'center'} whiteSpace={'wrap'} gap={'20px'} padding={'10px 20px'}>
                                    {
                                        !isNaN(this.state.percentageNormalizations) && this.state.percentageNormalizations > 0 && (
                                            <Box textAlign={'center'} style={{background: '#f4f4f4', padding: '10px 30px'}}>
                                                <Typography variant="body2">
                                                Total
                                                </Typography>
                                                <Gauge width={100} height={100} startAngle={-110} endAngle={110} value={this.state.percentageNormalizations} sx={(theme) => ({
                                                                    [`& .${gaugeClasses.valueArc}`]: {
                                                                    fill: this.state.percentageNormalizations > 95 ? '#4caf50' : this.state.percentageNormalizations > 50 ? '#ffc107' : '#f44336',
                                                                    }
                                                })}/>
                                            </Box>
                                        )
                                    }
                                    {
                                        this.state.lineChartLabels.map((value: string, index: number) => {
                                            return (
                                                <Box textAlign={'center'} className='left-border'>
                                                    <Typography variant="body2">
                                                    {
                                                        value
                                                    }
                                                    </Typography>
                                                    <Gauge width={100} height={100} startAngle={-110} endAngle={110} value={this.state.lineChartTotals[index]} sx={(theme) => ({
                                                            [`& .${gaugeClasses.valueArc}`]: {
                                                            fill: this.state.lineChartTotals[index] > 50 ? '#b28704' : '#aa2e25',
                                                            }
                                                        })}/>
                                                </Box>
                                            )
                                        })
                                    }
                                    {
                                        this.state.fieldsWithoutErrors.map((value: string, index: number) => {
                                            return (
                                                <Box textAlign={'center'} className='left-border'>
                                                    <Typography variant="body2">
                                                    {
                                                        value
                                                    }
                                                    </Typography>
                                                    <Gauge 
                                                        width={100} 
                                                        height={100} 
                                                        startAngle={-110} 
                                                        endAngle={110} 
                                                        value={100} 
                                                        sx={(theme) => ({
                                                            [`& .${gaugeClasses.valueArc}`]: {
                                                            fill: '#357a38',
                                                            }
                                                        })}
                                                    />
                                                </Box>
                                            )
                                        })
                                    }
                                </Stack>
                            </Box>
                        </React.Fragment>
                    )
                }
            </React.Fragment>
        )
    }

    private GetData(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/progress/errors/fields`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.GetErrorsTotal(response)
        });
    }

    private GetErrorsTotal(fieldsWithErrors: any[]): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/progress/errors/totals`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const normalizationActions = this.props.normalization.actions.split(',');
            
            const fieldsSuccess: any[] = [];
            for(let i = 0; i < normalizationActions.length; i++) {
                const normalizationAction = normalizationActions[i];
                let field = null;
                if (normalizationAction.toLowerCase() == 'nombres') {
                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'Apellidos';
                    });

                    if(field == null) {
                        fieldsSuccess.push('Apellidos');
                    }

                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'Nombre';
                    });

                    if(field == null) {
                        fieldsSuccess.push('Nombre');
                    }
                }

                if (normalizationAction.toLowerCase() == 'direcciones') {
                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'TipoVia';
                    });

                    if(field == null) {
                        fieldsSuccess.push('Tipo de vía');
                    }

                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'NombreVia';
                    });

                    if(field == null) {
                        fieldsSuccess.push('Nombre de la vía');
                    }

                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'NumeroVia';
                    });

                    if(field == null) {
                        fieldsSuccess.push('Número de la vía');
                    }

                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'RestoDireccion';
                    });

                    if(field == null) {
                        fieldsSuccess.push('R. de la dirección');
                    }

                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'Municipio';
                    });

                    if(field == null) {
                        fieldsSuccess.push('Municipio');
                    }

                    field = fieldsWithErrors.find((value: any) => {
                        return value.campo == 'Provincia';
                    });

                    if(field == null) {
                        fieldsSuccess.push('Provincia');
                    }
                }
            }

            let total: number = 0;
            for(let i = 0; i < fieldsWithErrors.length; i++) {
                total += this.GetErrorsTotalByField(fieldsWithErrors[i].campo)
            }
            
            this.SetlineChartLabels(fieldsWithErrors, fieldsSuccess, response, total);
        });
    }

    private SetlineChartLabels(fieldsWithErrors: any[], fieldsWithoutErrors: any[], response: any[], total:number) {
        const errores: any[] = this.state.errorCount;
        const lineChartLabels = [];
        const lineChartTotals = [];
        const erroresTotal = [];

        for(var i = 0; i < errores.length; i++) {
            lineChartLabels.push(errores[i].campo);
            lineChartTotals.push(Math.round(((this.state.itemCount - errores[i].errores) * 100) / this.state.itemCount));
            erroresTotal.push(errores[i].errores);
        }

        let sumaAciertos: number = 0;
        let sumaErrores: number = 0;

        for (var i = 0; i < erroresTotal.length; i++) {
            sumaAciertos += (this.state.itemCount - erroresTotal[i]);
            sumaErrores += erroresTotal[i];
        }

        for (var i = 0; i < fieldsWithoutErrors.length; i++) {
            sumaAciertos += this.state.itemCount;
        }

        console.log('this.state.itemCount', this.state.itemCount);

        console.log((100 - Math.round((sumaErrores / sumaAciertos) * 100)));

        this.setState({
            fieldsWithErrors: fieldsWithErrors,
            errorCount: response,
            totalErrors: total,
            totalSuccess: sumaAciertos,
            lineChartLabels: lineChartLabels,
            lineChartTotals: lineChartTotals,
            percentageNormalizations: 100 - Math.round((sumaErrores / sumaAciertos) * 100),
            fieldsWithoutErrors: fieldsWithoutErrors
        });
    }

    private GetTotal(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/data/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState({
                itemCount: response[0].total
            });
        });
    }

    private GetErrorsTotalByField(field: string) {
        const errores: any[] = this.state.errorCount;
        const error = errores.find((a: any) => {
            return a.campo == field;
        });

        if(error != null) {
            return error.errores;
        }

        return 0;
    }

    private GetNormalizationData(): void {
        let url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/data`;

        if(this.props.normalization.status == "Consolidada") {
            url = `${Common.END_POINT}/normalizaciones/${this.props.normalization.id}/consolidated`;
        }
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response
                }
            );
        });
    }
}